export default function zipcodeFormatter(value: string): string {
  if (!value) return '';
  return value.replace(/^(\d{0,5})(\d{0,3}).*/, '$1-$2').replace(/-$/, '');
}
